/* eslint-disable react/jsx-sort-props */

/**
 * DO NOT MODIFY THIS ICON DIRECTLY.
 *
 * THIS ICON WAS AUTOMATICALLY GENERATED.
 * SVG RETRIEVED FROM SPRING FOUNDATIONS FIGMA FILE.
 * @see https://www.figma.com/design/kcg95u086DD7Sa9or8Bwpq/%F0%9F%8C%B1--Foundations---Spring-2.0?node-id=24-2&p=f&t=75lUXy0FPOr0htKP-0
 */
import React from 'react';

import {Icon as BaseIcon, type BaseIconProps} from './Icon/Icon';
import {IconComponent} from './types';

export const LinkIcon = React.forwardRef<HTMLDivElement, BaseIconProps>(
  ({size = 16, ...props}, ref) => {
    return (
      <BaseIcon {...props} size={size} ref={ref}>
        <svg
          data-wf-icon="LinkIcon"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g>
            <g>
              <path
                d="M8.14643 4.14667C9.17012 3.12298 10.8298 3.12298 11.8535 4.14667C12.8772 5.17036 12.8772 6.83009 11.8535 7.85378L10.8535 8.85378L10.1464 8.14667L11.1464 7.14667C11.7796 6.51351 11.7796 5.48695 11.1464 4.85378C10.5133 4.22062 9.4867 4.22061 8.85354 4.85378L7.85354 5.85378L7.14643 5.14667L8.14643 4.14667Z"
                fill="currentColor"
              />
              <path
                d="M5.85354 7.85378L4.85354 8.85378C4.22037 9.48695 4.22037 10.5135 4.85354 11.1467C5.4867 11.7798 6.51326 11.7798 7.14643 11.1467L8.14643 10.1467L8.85354 10.8538L7.85353 11.8538C6.82984 12.8775 5.17012 12.8775 4.14643 11.8538C3.12274 10.8301 3.12274 9.17036 4.14643 8.14667L5.14643 7.14667L5.85354 7.85378Z"
                fill="currentColor"
              />
              <path
                d="M6.85354 9.85378L9.85354 6.85378L9.14643 6.14667L6.14643 9.14667L6.85354 9.85378Z"
                fill="currentColor"
              />
            </g>
          </g>
        </svg>
      </BaseIcon>
    );
  }
) as IconComponent;

LinkIcon.tags = ['url', 'link', 'chain', 'connect', 'attach'];

LinkIcon.category = 'General Icons';

LinkIcon.iconSize = 16;
